import { Link, Outlet } from '@tanstack/react-router';
import { useContext, type ReactNode } from 'react';
import { SessionContext } from '../router';
import { IconDoc, IconHome, IconLogout, IconSync } from './icons';
import { ThemeToggle, Wordmark } from './ui';
import { ROLE_LABEL } from '../lib/queries';

const NAV: { to: string; label: string; icon: ReactNode }[] = [
  { to: '/', label: 'Início', icon: <IconHome /> },
  { to: '/editais', label: 'Editais', icon: <IconDoc /> },
  { to: '/sincronizacao', label: 'Sincronização', icon: <IconSync /> },
];

export default function Shell() {
  const { me, staging, signOut } = useContext(SessionContext);
  return (
    <div className="flex min-h-dvh">
      <aside className="hidden w-[220px] shrink-0 flex-col border-r border-line bg-bg-2 px-2.5 py-4 lg:flex">
        <div className="flex items-center gap-2 px-2">
          <Wordmark />
          <span className="app-chip app-chip-accent">backoffice</span>
        </div>
        <nav aria-label="Backoffice" className="mt-6 flex flex-col gap-0.5">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className="app-nav-link" activeOptions={{ exact: n.to === '/' }}>
              {n.icon}
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="flex-1" />
        <div className="px-2 text-[11px] text-mute">
          {me ? (
            <>
              <div className="truncate text-fg-2">{me.user.email}</div>
              <div>{ROLE_LABEL[me.user.role] ?? me.user.role}</div>
            </>
          ) : null}
          <div className="mt-1">{staging ? 'Staging' : 'Produção'}</div>
        </div>
      </aside>
      <div className="min-w-0 flex-1">
        <header className="flex h-12 items-center justify-between gap-3 border-b border-line px-4 sm:px-6">
          <nav aria-label="Backoffice (compacto)" className="flex gap-0.5 overflow-x-auto lg:hidden">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} className="app-nav-link shrink-0" activeOptions={{ exact: n.to === '/' }}>
                {n.label}
              </Link>
            ))}
          </nav>
          <span className="hidden text-[12px] text-mute lg:inline">{me?.user.email}</span>
          <div className="flex items-center gap-1.5">
            <button type="button" className="app-btn app-btn-ghost" onClick={signOut}>
              <IconLogout size={15} /> Sair
            </button>
            <ThemeToggle />
          </div>
        </header>
        <main id="conteudo" className="mx-auto w-full max-w-[1280px] px-4 py-5 sm:px-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
